// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".PaperNewsStory-cls1___c7d57f0a687e58d70be{/*!*/}.PaperNewsStory-cls2__ee316e5111ff49ddff00{display:flex;flex-direction:column;align-items:flex-start;align-self:stretch;grid-gap:8px;gap:8px;grid-gap:var(--spacing-xs-8, 8px);gap:var(--spacing-xs-8, 8px);display:inline-block}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "PaperNewsStory-cls1___c7d57f0a687e58d70be",
	"cls2": "PaperNewsStory-cls2__ee316e5111ff49ddff00 PaperNewsStory-cls1___c7d57f0a687e58d70be"
};
export default ___CSS_LOADER_EXPORT___;
